<template>
  <div>
   <el-dialog
       title="提示"
       :visible.sync="dialogVisible"
       width="350px"
       append-to-body
       >
       <div class="dialog-content">
         <span >钉钉审批已停用，请刷新后重试</span>
       </div>
       <span slot="footer" class="dialog-footer">
         <el-button @click="dialogVisible = false">取消</el-button>
         <el-button  type="primary" @click="reloadClick">{{ controlBtnName }}</el-button>
       </span>
     </el-dialog>
  </div>
 </template>

<script>
export default {
  props: {
    controlBtnName: {
      type: String,
      default: '刷新'
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  watch: {

  },
  mounted () {
  },
  methods: {
    // 刷新
    reloadClick () {
      this.$emit('reloadClick')
      this.dialogVisible = false
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

 <style scoped lang='scss'>
 .dialog-content{
   padding: 10px;
   padding-bottom: 30px;
 }

 </style>

